export const Request = 'cache/request';
export const Refresh = 'cache/refresh';
export const Remove = 'cache/remove';
export const Retrieve = 'cache/retrieve';
export const Update = 'cache/update';
export const Error = 'cache/error';
